// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"231":"checkout","443":"about","596":"404","907":"history-detail","908":"history"}[chunkId] + "." + {"231":"7adb343e","443":"73b33d46","596":"9f1e9e8d","907":"70bb0983","908":"479e24f6"}[chunkId] + ".css";
};